export default {
	inProcessDev: `Страница находится в процессе разработки! <br/>Скоро вы сможете использовать все ее функции.<br/> <strong>Спасибо за понимание </strong>`,
}